<dl-sidebar-container>
  <dl-sidebar title="Navigatem.Access">
    <dl-sidebar-button
      *ngIf="hasScope('pageAccess:personal-stammdaten')"
      routerLinkActive="active"
      [matchRouterLinkExact]="false"
      [queryParamsHandling]="'preserve'"
      [routerLink]="'/personal-stammdaten'"
    >
      <dl-sidebar-button-image
        src="assets/icons/black/user.svg"
      ></dl-sidebar-button-image>
      <dl-sidebar-button-text>Personal</dl-sidebar-button-text>
    </dl-sidebar-button>
    <dl-sidebar-button
      *ngIf="hasScope('pageAccess:tagesplaene')"
      routerLinkActive="active"
      [matchRouterLinkExact]="false"
      [queryParamsHandling]="'preserve'"
      [routerLink]="'/tagesplaene'"
    >
      <dl-sidebar-button-image
        src="assets/icons/today-outline.svg"
      ></dl-sidebar-button-image>
      <dl-sidebar-button-text>Tagespläne</dl-sidebar-button-text>
    </dl-sidebar-button>
    <dl-sidebar-button
      *ngIf="hasScope('pageAccess:wochenplaene')"
      routerLinkActive="active"
      [matchRouterLinkExact]="false"
      [queryParamsHandling]="'preserve'"
      [routerLink]="'/wochenplaene'"
    >
      <dl-sidebar-button-image
        src="assets/icons/week-outline.svg"
      ></dl-sidebar-button-image>
      <dl-sidebar-button-text>Wochenpläne</dl-sidebar-button-text>
    </dl-sidebar-button>
    <dl-sidebar-button
      *ngIf="hasScope('pageAccess:buchungen')"
      routerLinkActive="active"
      [matchRouterLinkExact]="false"
      queryParamsHandling="preserve"
      routerLink="/buchungen"
    >
      <div class="badge-list">
        @if (countOpenWithoutMonteureAntraege$ | async) {
          <ion-badge color="primary">{{
            countOpenWithoutMonteureAntraege$ | async
          }}</ion-badge>
        }
      </div>
      <dl-sidebar-button-image
        src="assets/icons/stopwatch-outline.svg"
      ></dl-sidebar-button-image>
      <dl-sidebar-button-text>Buchungen</dl-sidebar-button-text>
    </dl-sidebar-button>
    <dl-sidebar-button
      *ngIf="hasScope('pageAccess:buchungskorrekturen-monteure')"
      routerLinkActive="active"
      [matchRouterLinkExact]="false"
      [routerLink]="'/buchungskorrekturen-monteure'"
      queryParamsHandling="preserve"
    >
      <div class="badge-list">
        @if (countOpenMonteureAntraege$ | async) {
          <ion-badge color="primary">{{
            countOpenMonteureAntraege$ | async
          }}</ion-badge>
        }
      </div>
      <dl-sidebar-button-image
        src="assets/icons/construct-outline.svg"
      ></dl-sidebar-button-image>
      <dl-sidebar-button-text
        >Buchungskorrektur Monteure</dl-sidebar-button-text
      >
    </dl-sidebar-button>
    <dl-sidebar-button
      *ngIf="hasScope('pageAccess:fehlerliste')"
      routerLinkActive="active"
      [matchRouterLinkExact]="false"
      [routerLink]="'/fehlerliste'"
      queryParamsHandling="preserve"
    >
      <dl-sidebar-button-image
        src="assets/icons/warning-outline.svg"
      ></dl-sidebar-button-image>
      <dl-sidebar-button-text>Fehlerliste</dl-sidebar-button-text>
    </dl-sidebar-button>
    <dl-sidebar-button
      *ngIf="hasScope('pageAccess:kalender')"
      routerLinkActive="active"
      [matchRouterLinkExact]="false"
      [routerLink]="'/kalender'"
      queryParamsHandling="preserve"
    >
      <dl-sidebar-button-image
        src="assets/icons/calendar-outline.svg"
      ></dl-sidebar-button-image>
      <dl-sidebar-button-text>Kalenderansicht</dl-sidebar-button-text>
    </dl-sidebar-button>

    <dl-sidebar-button
      *ngIf="hasScope('pageAccess:auswertungen')"
      [routerLink]="'/auswertungen/tabelle'"
      [matchRouterLinkExact]="false"
      [queryParamsHandling]="'preserve'"
      routerLinkActive="active"
    >
      <dl-sidebar-button-image
        src="assets/icons/black/users.svg"
      ></dl-sidebar-button-image>
      <dl-sidebar-button-text>Auswertungen</dl-sidebar-button-text>
    </dl-sidebar-button>

    <dl-sidebar-button
      *ngIf="hasScope('pageAccess:auswertungen:erstellen')"
      [matchRouterLinkExact]="false"
      [routerLink]="'/auswertungen/erstellen'"
      [queryParamsHandling]="'preserve'"
      routerLinkActive="active"
    >
      <dl-sidebar-button-image
        src="assets/icons/document-text-outline.svg"
      ></dl-sidebar-button-image>
      <dl-sidebar-button-text>Auswertung erstellen</dl-sidebar-button-text>
    </dl-sidebar-button>

    <dl-sidebar-button
      *ngIf="hasScope('pageAccess:umbuchungen')"
      [routerLink]="'/umbuchungen'"
      routerLinkActive="active"
      [matchRouterLinkExact]="false"
      [queryParamsHandling]="'preserve'"
    >
      <dl-sidebar-button-image
        src="assets/icons/swap-horizontal-outline.svg"
      ></dl-sidebar-button-image>
      <dl-sidebar-button-text>Umbuchungen</dl-sidebar-button-text>
    </dl-sidebar-button>

    @if (
      hasScope('pageAccess:layouts') && hasScope('monatsauswertungLayout:read')
    ) {
      <dl-sidebar-button
        [matchRouterLinkExact]="false"
        [routerLink]="'/layouts/monatsauswertungen'"
        routerLinkActive="active"
        [queryParamsHandling]="'preserve'"
      >
        <dl-sidebar-button-image
          src="assets/icons/table-chart.svg"
        ></dl-sidebar-button-image>
        <dl-sidebar-button-text>Layouts</dl-sidebar-button-text>
      </dl-sidebar-button>
    } @else if (
      hasScope('pageAccess:layouts') &&
      hasScope('aggregierteAuswertungLayout:read')
    ) {
      <dl-sidebar-button
        [matchRouterLinkExact]="false"
        [routerLink]="'/layouts/aggregierteauswertungen'"
        [queryParamsHandling]="'preserve'"
        routerLinkActive="active"
      >
        <dl-sidebar-button-image
          src="assets/icons/table-chart.svg"
        ></dl-sidebar-button-image>
        <dl-sidebar-button-text>Layouts</dl-sidebar-button-text>
      </dl-sidebar-button>
    }

    <dl-sidebar-button
      *ngIf="hasScope('pageAccess:urlaubsantraege')"
      [matchRouterLinkExact]="false"
      [routerLink]="'/urlaubsantraege'"
      routerLinkActive="active"
    >
    <div class="badge-list">
      @if ((hasScope('urlaubsantraege:read:all') || hasScope('urlaubsantraege:read:unit:own') || hasScope('urlaubsantraege:read:unit:lead')) && (countOpenUrlaubsantraege$ | async)) {
        <ion-badge color="primary">{{(countOpenUrlaubsantraege$ | async)}}</ion-badge>
      }
    </div>
      <dl-sidebar-button-image
        src="assets/icons/plane.svg"
      ></dl-sidebar-button-image>
      <dl-sidebar-button-text> Urlaubsanträge </dl-sidebar-button-text>
    </dl-sidebar-button>
    <dl-sidebar-button
      *ngIf="hasScope('pageAccess:zutrittskontrolle')"
      [matchRouterLinkExact]="false"
      [routerLink]="'/zutrittskontrolle'"
      routerLinkActive="active"
      [queryParamsHandling]="'preserve'"
    >
      <dl-sidebar-button-image
        src="assets/icons/shield-half-outline.svg"
      ></dl-sidebar-button-image>
      <dl-sidebar-button-text> Zutrittskontrolle </dl-sidebar-button-text>
    </dl-sidebar-button>
    <dl-sidebar-button
      *ngIf="hasScope('zutrittskontrolle:verwaltung:all')"
      [matchRouterLinkExact]="false"
      [routerLink]="'/zutrittsprotokoll'"
      routerLinkActive="active"
    >
      <dl-sidebar-button-image
        src="assets/icons/document-text-outline.svg"
      ></dl-sidebar-button-image>
      <dl-sidebar-button-text> Zutrittsprotokoll </dl-sidebar-button-text>
    </dl-sidebar-button>
    <dl-sidebar-button
      *ngIf="hasScope('pageAccess:geraeteliste')"
      [matchRouterLinkExact]="false"
      [routerLink]="'/geraeteliste'"
      routerLinkActive="active"
      [queryParamsHandling]="'preserve'"
    >
      <dl-sidebar-button-image
        src="assets/icons/clipboard-outline.svg"
      ></dl-sidebar-button-image>
      <dl-sidebar-button-text> Geraeteliste </dl-sidebar-button-text>
    </dl-sidebar-button>
    <dl-sidebar-button
      slot="end"
      *ngIf="($isLoggedIn | async) === true"
      (click)="onLogout()"
    >
      <dl-sidebar-button-image
        src="assets/icons/log-out-outline.svg"
      ></dl-sidebar-button-image>
      <dl-sidebar-button-text>Abmelden</dl-sidebar-button-text>
    </dl-sidebar-button>
  </dl-sidebar>

  <dl-sidebar-content>
    <ion-router-outlet
      style="margin-left: 60px"
      [animated]="false"
    ></ion-router-outlet>
  </dl-sidebar-content>
</dl-sidebar-container>
